import { appInfo } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-5xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-shrink-0 w-48 md:w-56">
            <div className="aspect-[3/4] rounded-2xl overflow-hidden shadow-lg">
              <img
                src={appInfo.image}
                alt="吃瓜视频移动端界面展示"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">{appInfo.title}</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg">
              {appInfo.desc}
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mb-6">
              {appInfo.features.map((f) => (
                <span key={f} className="px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium whitespace-nowrap">
                  <i className="ri-check-line mr-1"></i>{f}
                </span>
              ))}
            </div>
            <button className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-smartphone-line"></i>
              收藏到手机桌面
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}